import sign from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import CryptoJS from "crypto-js";

const SECRET = process.env.REACT_APP_JWT_SECRET;
const PAYLOAD_SECRET = process.env.REACT_APP_PAYLOAD_SECRET;

/**
 * @name encodePayload
 * @description Encrypts the data passed by parameters.
 * @param {object} data
 * @returns {string} Encrypted data.
 * @author Jesús Sánchez Fernández
 */
const encodePayload = (data) => {
  try {
    const payloadString = JSON.stringify(data);
    const encryptedPayload = CryptoJS.AES.encrypt(payloadString, PAYLOAD_SECRET).toString();
    return encryptedPayload;
  } catch (error) {
    console.error("🚀 ~ encodePayload ~ error", error);
  }
};

/**
 * @name decodePayload
 * @description Decrypts the data passed by parameters.
 * @param {string} data
 * @returns {object} Decrypted data.
 * @author Jesús Sánchez Fernández
 */
const decodePayload = (data) => {
  const decryptedBytes = CryptoJS.AES.decrypt(data, PAYLOAD_SECRET);
  const decryptedPayloadString = decryptedBytes.toString(CryptoJS.enc.Utf8);
  const decryptedPayload = JSON.parse(decryptedPayloadString);
  return decryptedPayload;
};

/**
 *
 * @name encodeToken
 * @description Encrypts data passed by parameters.
 * @param {object} data
 * @returns {string} Token.
 *
 */
export const encodeToken = (data) => {
  data = encodePayload(data);

  const encodeToken = sign(
    {
      data,
    },
    SECRET,
    {
      expiresIn: "1h",
    }
  );

  return encodeToken;
};

/**
 *
 * @name decodeToken
 * @description Decrypts the token that is passed to it by parameters.
 * @param {string} token
 * @returns {object} Data.
 *
 */
export const decodeToken = (token) => {
  try {
    const { data } = jwtDecode(token, SECRET);
    return decodePayload(data);
  } catch (error) {
    return false;
  }
};
